<template>
  <v-container class="grey lighten-5 mt-5" xs="12">
    <ReportDialog ref="reportDialog"></ReportDialog>
    <CommentDialog ref="commentDialog"></CommentDialog>

    <!--Dialog when share button is clicked-->
    <v-dialog v-model="shareDialog" max-width="600px" class="ma-0">
      <v-card>
        <v-row class="ma-0 pa-0 exitShare">
          <v-btn icon @click="shareDialog = false">
            <v-icon small>fas fa-times</v-icon>
          </v-btn>
        </v-row>

        <v-list>
          <v-list-item>
            <v-text-field
              class="ma-5 pa-5"
              readonly
              color="primary"
              v-model="shareURL"
              ref="getShareURL"
              type="text"
              auto-grow
              single-line
              full-width
            >
              <template v-slot:append>
                <v-btn tile color="primary" text class="ma-0" @click="copy"
                  >copy</v-btn
                >
              </template>
            </v-text-field>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>

    <v-row height="100%">
      <!--The Main article (bigger picture than rest)-->
      <v-col
        class="mainCol"
        v-for="card in News.slice(0, 1)"
        :key="card.id"
        cols="12"
        lg="6"
        md="6"
        sm="12"
      >
        <v-row>
          <v-col>
            <v-card
              class="pa-2 noBorder d-flex flex-column"
              id="mainCard"
              outlined
              flat
              tile
            >
              <v-card-actions>
                <v-card-text justify="start" class="pa-2">
                  <span class="authorText">{{ card.NickName }}</span> |
                  <span class="dateText">{{ card.Date }}</span>
                </v-card-text>
                <v-menu offset-y left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon class="cardIcon" v-bind="attrs" v-on="on">
                      <v-icon small>fas fa-ellipsis-h</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="bookmark()">
                      <v-list-item-title>
                        <v-btn icon class="cardIcon">
                          <v-icon small>far fa-bookmark</v-icon>
                        </v-btn>
                        {{ $t("Bookmark article") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click.stop="
                        $refs.reportDialog.openDialog({
                          reportedId: card.id,
                          reportType: 'article',
                          content: card.Title,
                        })
                      "
                    >
                      <v-list-item-title>
                        <v-btn icon class="cardIcon">
                          <v-icon small>fas fa-exclamation-triangle</v-icon>
                        </v-btn>
                        {{ $t("Report") }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-card-actions>

              <v-card
                class="noBorder"
                outlined
                flat
                tile
                :to="{
                  name: `frontpage`,
                  params: { articleid: card.id },
                }"
              >
                <v-img
                  v-if="card.MediaData && card.MediaData.length > 0"
                  :src="`${card.MediaData[0]['s3url']}-web.jpg`"
                  class="mainCatimg"
                  cover
                >
                </v-img>
                <v-img v-else :src="`/lrVxWoHA.png`" class="mainCatimg" contain>
                </v-img>

                <p
                  class="font-weight-bold mainCardTitle pt-1 mb-2 pb-1"
                  style="display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;"
                  v-html="card.Title"
                ></p>
                <div
                  class="body-1 mainContent"
                  style="display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;"
                  v-html="card.Content"
                />
              </v-card>

              <v-spacer></v-spacer>
              <v-card-actions
                class="pa-0 align-end"
                justify="center"
                align="center"
              >
                <v-col>
                  <v-btn icon small class="cardIcon">
                    <v-icon small>fas fa-book-reader</v-icon>
                    <span class="metaCount">{{ card.Views }}</span>
                  </v-btn>
                </v-col>

                <v-col>
                  <v-btn icon small class="cardIcon">
                    <v-icon small>far fa-comment-alt</v-icon>
                    <span class="metaCount">{{ card.Comments }}</span>
                  </v-btn>
                </v-col>

                <v-col>
                  <v-btn icon small class="cardIcon" @click="share(card.id)">
                    <v-icon small>fas fa-share-alt</v-icon>
                    {{ $t("Share") }}
                  </v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <!-- Medium sized TECH articles-->
      <v-col cols="12" lg="6" md="6" sm="12" xs="12">
        <v-row>
          <v-col
            class="middleCol"
            v-for="card in News.slice(1, 3)"
            :key="card.id"
            cols="12"
            lg="12"
            md="12"
            sm="6"
            xs="6"
          >
            <v-card
              class="pl-2 pr-2 pt-2 pb-0 noBorder d-flex flex-column middleCard"
              outlined
              flat
              tile
            >
              <v-card-actions class="pa-0 ma-0">
                <v-card-text justify="start" class="pa-2">
                  <span class="authorText pa-0">{{ card.NickName }}</span>
                  |
                  <span
                    class="dateText"
                    :style="
                      $vuetify.breakpoint.smAndDown ? 'display:block' : ''
                    "
                    >{{ card.Date }}</span
                  >
                </v-card-text>

                <v-menu offset-y left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon class="cardIcon" v-bind="attrs" v-on="on">
                      <v-icon small>fas fa-ellipsis-h</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="bookmark()">
                      <v-list-item-title>
                        <v-btn icon class="cardIcon">
                          <v-icon small>far fa-bookmark</v-icon>
                        </v-btn>
                        {{ $t("Bookmark article") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click.stop="
                        $refs.reportDialog.openDialog({
                          reportedId: card.id,
                          reportType: 'article',
                          content: card.Title,
                        })
                      "
                    >
                      <v-list-item-title>
                        <v-btn icon class="cardIcon">
                          <v-icon small>fas fa-exclamation-triangle</v-icon>
                        </v-btn>
                        {{ $t("Report") }}
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="share(card.id)">
                      <v-list-item-title>
                        <v-btn icon small class="cardIcon">
                          <v-icon small>fas fa-share-alt</v-icon>
                        </v-btn>
                        {{ $t("Share") }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-card-actions>

              <v-card
                class="noBorder mt-0 pt-0"
                outlined
                flat
                tile
                :to="{
                  name: `frontpage`,
                  params: { articleid: card.id },
                }"
              >
                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pl-2 pr-1 pt-0 pb-0">
                    <p
                      class="font-weight-bold otherTitle pt-1 mb-0 pb-1"
                      style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;"
                      v-html="card.Title"
                    ></p>
                  </v-col>
                </v-row>

                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pa-0 pa-2 d-flex">
                    <v-img
                      v-if="card.MediaData && card.MediaData.length > 0"
                      class="mr-3 smallCatimg"
                      :src="`${card.MediaData[0]['s3url']}-web.jpg`"
                    ></v-img>
                    <div
                      class="body-1 userContent"
                      style="display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;"
                      v-html="card.Content"
                    />
                  </v-col>
                </v-row>
              </v-card>

              <v-spacer></v-spacer>
              <v-card-actions
                class="pa-0 align-end"
                justify="center"
                align="center"
              >
                <v-col>
                  <v-btn icon small class="cardIcon">
                    <v-icon small>fas fa-book-reader</v-icon>
                    <span class="metaCount">{{ card.Views }}</span>
                  </v-btn>
                </v-col>

                <v-col>
                  <v-btn
                    icon
                    small
                    class="cardIcon"
                    @click.stop="
                      $refs.commentDialog.openDialog({
                        Content: '',
                        Articles_id: card.id,
                        ArticleComments_id: card.id,
                      })
                    "
                  >
                    <v-icon small>far fa-comment-alt</v-icon>
                    <span class="metaCount">{{ card.Comments }}</span>
                  </v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/*
How this module works:

This module shows the top articles on the website. All contains image
and are new and relevant
*/

import { mapGetters, mapActions } from "vuex";
import messages from "../../modules/lang/main/export";
import ReportDialog from "@/components/dialogs/report_dialog.vue";
import CommentDialog from "@/components/dialogs/kommentar_dialog.vue";
export default {
  i18n: { messages },

  components: {
    ReportDialog,
    CommentDialog,
  },

  data() {
    return {
      shareDialog: false,
      shareURL: window.location.href,
    };
  },
  props: {
    news: {
      type: Array,
    },
  },

  computed: {
    ...mapGetters(["getRemainingNews"]),

    News() {
      let data = JSON.parse(JSON.stringify(this.news));
      let res = [];
      for (const el of data) {
        el.Date = this.parseDate(el.Created);
        res.push(el);
      }
      return res;
    },
  },

  methods: {
    parseDate(published) {
      //This date is visible outside the cards. Format examples:
      //Less than 24h ago: 20m (if under 60m ago), else 20h
      //This year: Jun 10
      //Longer time ago: Jun 10, 2019
      published = new Date(published);
      let now = new Date();
      let diff = now.getTime() - published.getTime();

      let hoursAgo = diff / 3600000;
      if (hoursAgo < 24) {
        let minAgo = diff / 60000;
        if (minAgo < 60) {
          return Math.floor(minAgo) + "m";
        } else {
          return Math.floor(hoursAgo) + "h";
        }
      } else {
        const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
          published
        );
        const mo = new Intl.DateTimeFormat("en", { month: "long" }).format(
          published
        );
        const da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
          published
        );
        if (published.getYear == now.getYear) {
          return mo + " " + da; //e.g. Jul 28
        } else {
          return mo + " " + da + ", " + ye; //e.g. Jul 28, 2019
        }
      }
    },

    setMainCardHeigh() {
      //Set height of main card based on middle cards
      let height = document.getElementsByClassName("middleCard")[0]
        .clientHeight;
      document.getElementById("mainCard").style.height = 2 * height + 23 + "px";
    },

    bookmark() {
      //TODO
    },
    share(id) {
      this.shareURL = location.origin + "/api/share/" + id;
      this.shareDialog = true; //Opens share dialog
    },
    copy() {
      let textInput = this.$refs.getShareURL.$el.querySelector("input");
      textInput.select();
      document.execCommand("copy");
    },
  },
};
</script>

<style scoped>
.cardIcon {
  margin: 0px 10px 0px 0px;
  opacity: 0.8;
}

.cardIconSmall {
  display: inline-block;
}

.noBorder {
  border: 0 !important;
}

.dateText {
  color: #666;
  font-size: 0.8em;
}

.authorText {
  font-weight: bold;
  font-size: 0.8em;
}

.metaCount {
  color: #ff5252;
  padding-left: 5px;
  font-size: 1.2em;
}

.mainCatimg {
  height: 320px !important;
}

.middleCatimg {
  height: 100px !important;
}

.smallCatimg {
  height: 120px !important;
  width: 120px !important;
}

.techCol {
  color: rgb(14, 165, 0) !important;
}

.middleCardTitle {
  height: 105px;
  overflow: hidden;
  font-size: 1.4em;
}

.mainCardTitle {
  font-size: 1.6em !important;
  max-height: 110px;
  overflow: hidden;
}

.otherTitle {
  font-size: 1.4em !important;
}

.userContent {
  font-size: 0.9em !important;
}

.views {
  text-transform: lowercase !important;
  opacity: 1 !important;
  padding-left: px;
}

.mainContent {
  font-size: 1em !important;
}

#shareDialog {
  max-width: 300px !important;
}
.exitShare {
  justify-content: end;
}

.imgDiv {
  font-size: 1em;
  color: white;
  justify-content: "end";
  background-color: #02577a;
  display: inline-block;
  padding: 0 8px;
  font-weight: 400;
  position: absolute;
  margin: 0;
  bottom: 0;
}

@media (max-width: 1264px) {
  .mainCatimg {
    height: 300px !important;
  }
  .mainContent {
    font-size: 0.9em !important;
  }
}

@media (max-width: 960px) {
  .mainCatimg {
    height: auto !important;
    max-height: 450px !important;
  }

  #mainCard {
    height: auto !important;
    margin: 0;
    padding: 4px 2px 4px 2px;
  }

  .middleCol {
    padding: 6px 3px 6px 3px;
  }

  .mainCol {
    margin: 0px;
    padding: 4px 2px 4px 2px;
  }

  .smallCatimg {
    height: 100px !important;
    width: 100px !important;
  }

  .otherTitle {
    font-size: 1.2em !important;
  }

  .userContent {
    font-size: 0.8em !important;
  }

  .mainContent {
    font-size: 1em !important;
  }
}

@media (max-width: 600px) {
  .mainCardTitle {
    font-size: 1.3em !important;
  }

  .smallCatimg {
    height: 90px !important;
    width: 90px !important;
  }

  .otherTitle {
    font-size: 1em !important;
  }

  .userContent {
    font-size: 0.7em !important;
  }

  .mainContent {
    font-size: 0.8em !important;
  }
}
</style>
